import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { Layout } from 'components/Layout'
import { BestFriend } from './components/BestFriend'
import { CoatHealth } from './components/CoatHealth'
import { FoodForDigestiveIssues } from './components/FoodForDigestiveIssues'
import { FoodForDogsWithAllergies } from './components/FoodForDogsWithAllergies'
import { FoodForUrinaryHealth } from './components/FoodForUrinaryHealth'
import { FoodForWeightLoss } from './components/FoodForWeightLoss'
import { Hero } from './components/Hero'
import { PickyEaters } from './components/PickyEaters'
import { RawDiet } from './components/RawDiet'
import { RawBenefitsRoot } from './RawBenefits.styles'

export const RawBenefits = () => {
  const header = <Header />
  return (
    <Layout header={header}>
      <RawBenefitsRoot>
        <Hero />
        <RawDiet />
        <FoodForDigestiveIssues />
        <FoodForDogsWithAllergies />
        <CoatHealth />
        <FoodForUrinaryHealth />
        <FoodForWeightLoss />
        <PickyEaters />
        <BestFriend />
        <Footer />
      </RawBenefitsRoot>
    </Layout>
  )
}
